import { render } from "./updateTags.vue?vue&type=template&id=12380392"
import script from "./updateTags.vue?vue&type=script&lang=js"
export * from "./updateTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__